import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/group.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-31babb22")

_pushScopeId("data-v-31babb22")
const _hoisted_1 = { class: "desktop-grid" }
const _hoisted_2 = { class: "w100" }
const _hoisted_3 = { style: {"width":"10%"} }
const _hoisted_4 = { style: {"width":"5%","text-align":"center"} }
const _hoisted_5 = { class: "thead-cell-center" }
const _hoisted_6 = {
  class: "thead-cell-center",
  style: {"width":"5%"}
}
const _hoisted_7 = {
  class: "desktop-table-action",
  style: {"width":"5%"}
}
const _hoisted_8 = { class: "thead-cell-center" }
const _hoisted_9 = { class: "desktop-table-text-setting drag-handle" }
const _hoisted_10 = /*#__PURE__*/_createVNode("img", {
  class: "group-icon",
  src: _imports_0
}, null, -1)
const _hoisted_11 = { class: "desktop-table-text-setting item drag-handle" }
const _hoisted_12 = { class: "cuted-cell" }
const _hoisted_13 = { class: "desktop-table-text-setting drag-handle" }
const _hoisted_14 = { class: "desktop-table-text-setting drag-handle" }
const _hoisted_15 = { class: "desktop-table-text-setting drag-handle" }
const _hoisted_16 = { class: "cuted-cell" }
const _hoisted_17 = { class: "desktop-table-text-setting text-center drag-handle" }
const _hoisted_18 = {
  key: 0,
  class: "icon-f icon-check fs-16 no-pointer"
}
const _hoisted_19 = {
  key: 1,
  class: "icon-f icon-delete-cross fs-16 no-pointer",
  style: {"color":"#fd695a"}
}
const _hoisted_20 = { class: "desktop-table-text-setting drag-handle" }
const _hoisted_21 = { class: "desktop-table-text-setting drag-handle" }
const _hoisted_22 = {
  key: 0,
  class: "status-green"
}
const _hoisted_23 = {
  key: 1,
  class: "status-red"
}
const _hoisted_24 = { class: "desktop-table-action text-center" }
const _hoisted_25 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-pencil-edit fs-16" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_draggable = _resolveComponent("draggable")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("table", _hoisted_2, [
      _createVNode("thead", null, [
        _createVNode("tr", null, [
          _createVNode("td", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('on-sort', 'Order'))),
            style: {"width":"8%"}
          }, [
            _createVNode("span", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('label.promoPosition')) + " ", 1),
              _createVNode("i", {
                class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Order')]
              }, null, 2)
            ])
          ]),
          _createVNode("td", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('on-sort', 'Name'))),
            style: {"width":"10%"}
          }, [
            _createVNode("span", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('promo.categoryName')) + " ", 1),
              _createVNode("i", {
                class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Name')]
              }, null, 2)
            ])
          ]),
          _createVNode("td", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('on-sort', 'Region'))),
            style: {"width":"15%"}
          }, [
            _createVNode("span", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('promo.region')) + " ", 1),
              _createVNode("i", {
                class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Region')]
              }, null, 2)
            ])
          ]),
          _createVNode("td", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('on-sort', 'ProductType'))),
            style: {"width":"10%"}
          }, [
            _createVNode("span", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('promo.productType')) + " ", 1),
              _createVNode("i", {
                class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('ProductType')]
              }, null, 2)
            ])
          ]),
          _createVNode("td", _hoisted_3, _toDisplayString(_ctx.$t('promo.tags')), 1),
          _createVNode("td", _hoisted_4, [
            _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('promo.photo')), 1)
          ]),
          _createVNode("td", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('on-sort', 'CreateDate'))),
            style: {"width":"7%"}
          }, [
            _createVNode("span", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('agencies.filter.createDate')) + " ", 1),
              _createVNode("i", {
                class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('CreateDate')]
              }, null, 2)
            ])
          ]),
          _createVNode("td", _hoisted_6, [
            _createVNode("span", null, _toDisplayString(_ctx.$t('agencies.isActive')), 1)
          ]),
          _createVNode("td", _hoisted_7, [
            _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('customerType.actions')), 1)
          ])
        ])
      ]),
      _createVNode("tbody", null, [
        _createVNode(_component_draggable, {
          class: "dragable-container",
          element: "table",
          handle: ".drag-handle",
          modelValue: _ctx.promotedCategories,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.promotedCategories = $event)),
          "item-key": "id",
          "scroll-sensitivity": 330,
          "force-fallback": true
        }, {
          item: _withId(({ element }) => [
            _createVNode("tr", null, [
              _createVNode("td", _hoisted_9, [
                _createTextVNode(_toDisplayString(element.order) + " ", 1),
                _hoisted_10
              ]),
              _createVNode("td", _hoisted_11, [
                _createVNode("div", _hoisted_12, _toDisplayString(element.name), 1)
              ]),
              _createVNode("td", _hoisted_13, _toDisplayString(_ctx.getRegionsName(element.promotedCategoryRegions)), 1),
              _createVNode("td", _hoisted_14, _toDisplayString(element.productTypeName), 1),
              _createVNode("td", _hoisted_15, [
                _createVNode("div", _hoisted_16, _toDisplayString(_ctx.getTagsName(element.subTagIds)), 1)
              ]),
              _createVNode("td", _hoisted_17, [
                (element.imagePath)
                  ? (_openBlock(), _createBlock("i", _hoisted_18))
                  : (_openBlock(), _createBlock("i", _hoisted_19))
              ]),
              _createVNode("td", _hoisted_20, _toDisplayString(_ctx.formatLocalDate(element.createDate)), 1),
              _createVNode("td", _hoisted_21, [
                (element.active)
                  ? (_openBlock(), _createBlock("span", _hoisted_22, _toDisplayString(_ctx.$t('label.active')), 1))
                  : (_openBlock(), _createBlock("span", _hoisted_23, _toDisplayString(_ctx.$t('label.notactive')), 1))
              ]),
              _createVNode("td", _hoisted_24, [
                _createVNode(_component_router_link, {
                  to: { name: 'editPromoCategory', params: { id: element.id } },
                  class: "m-0"
                }, {
                  default: _withId(() => [
                    _hoisted_25
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ])
  ]))
})